export enum EStatus {
    OPEN = 'OPEN',
    IN_PROGRESS = 'IN_PROGRESS',
    ONHOLD = 'ONHOLD',
    TO_REVIEW = 'TO_REVIEW',
    CANCELED = 'CANCELED',
    CLOSED = 'CLOSED',
}
